import { Service } from "../../../../AppDataProvider/types";

export type ServicesByCategory = {
  _id: string;
  name: string;
  order: number;
  services: Service[];
};

/**
 * Helper function to sort a list of Services by Category.
 * Used in the ServiceStep when more than one category is available.
 *
 * @param resources An array of Services to be sorted by category
 * @returns An array of ServicesByCategory objects, which contain the categoryId and
 *          categoryName, along with a list of Services which belong to that category
 */
export const sortServicesByCategory = (
  services: Service[],
): ServicesByCategory[] =>
  services
    .reduce((result: ServicesByCategory[], service: Service) => {
      const { _id, name, order } = service.category;

      const existingCategory = result.find((entry) => entry._id === _id);

      existingCategory !== undefined
        ? existingCategory.services.push(service)
        : result.push({
            _id,
            name,
            order: order ?? -1,
            services: [service],
          });

      return result;
    }, [])
    .sort((a, b) => a.order - b.order);

export default sortServicesByCategory;
